/* Mold Labs — velké oznámení v košíku ("zatím nepřijímáme objednávky").
   Samostatný skript: staví si vlastní DOM a barvy/rozměry nastavuje přímo na
   elementech, takže je imunní proti strip­ování stylů na live storu.
   Konfigurace přichází z window.MLNotice (inline v ml-header.liquid).
   Vypnutí: Customize → sekce Header → "Zobrazit oznámení v košíku" = off. */
(function () {
  var CFG = window.MLNotice || {};
  if (CFG.enabled === false) { return; }

  var GREEN = '#5ccc78', GREEN_INK = '#2f9c57', INK = '#0f0f0e';
  var BODY = '#5a5a52', LINE = '#ecece5';
  var KEY = 'ml-cart-notice-seen-v1';
  var SANS = "'Helvetica Neue', Helvetica, Arial, sans-serif";
  var MONO = "'Space Mono', ui-monospace, monospace";

  function css(el, s) { for (var k in s) { el.style[k] = s[k]; } return el; }
  function seen() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function markSeen() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }

  var open = false;

  function build() {
    var wrap = document.createElement('div');
    wrap.setAttribute('data-ml-notice', '');
    css(wrap, {
      position: 'fixed', inset: '0', zIndex: '2147483600', display: 'flex',
      alignItems: 'center', justifyContent: 'center', padding: '20px',
      boxSizing: 'border-box', fontFamily: SANS
    });

    var veil = document.createElement('div');
    css(veil, {
      position: 'absolute', inset: '0', background: 'rgba(15,15,14,.62)',
      backdropFilter: 'blur(3px)', WebkitBackdropFilter: 'blur(3px)',
      opacity: '0', transition: 'opacity .35s ease'
    });
    wrap.appendChild(veil);

    var card = document.createElement('div');
    css(card, {
      position: 'relative', width: '100%', maxWidth: '680px', boxSizing: 'border-box',
      background: '#fff', border: '1px solid ' + LINE, borderRadius: '22px',
      boxShadow: '0 34px 90px rgba(15,15,14,.34)', padding: '54px 56px 48px',
      textAlign: 'center', transform: 'translateY(26px) scale(.97)', opacity: '0',
      transition: 'transform .5s cubic-bezier(.22,1,.36,1), opacity .38s ease',
      maxHeight: 'calc(100vh - 40px)', overflowY: 'auto'
    });

    // zavírací křížek
    var close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', 'Zavřít');
    close.innerHTML = '&#215;';
    css(close, {
      position: 'absolute', top: '16px', right: '18px', width: '38px', height: '38px',
      appearance: 'none', border: '1px solid ' + LINE, background: '#fff', color: INK,
      borderRadius: '50%', fontSize: '20px', lineHeight: '1', cursor: 'pointer',
      fontFamily: 'inherit', transition: 'border-color .18s ease, background .18s ease'
    });
    close.onmouseenter = function () { close.style.borderColor = INK; close.style.background = '#f7f7f4'; };
    close.onmouseleave = function () { close.style.borderColor = LINE; close.style.background = '#fff'; };
    card.appendChild(close);

    // značka
    var mark = document.createElement('div');
    css(mark, {
      width: '62px', height: '62px', margin: '0 auto 26px', borderRadius: '16px',
      background: GREEN, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px',
      padding: '10px', boxSizing: 'border-box', alignContent: 'center'
    });
    for (var i = 0; i < 4; i++) {
      var dot = document.createElement('i');
      css(dot, { display: 'block', width: '100%', paddingBottom: '100%', borderRadius: '50%', background: GREEN_INK });
      mark.appendChild(dot);
    }
    card.appendChild(mark);

    var eyebrow = document.createElement('div');
    css(eyebrow, {
      fontFamily: MONO, fontSize: '11px', letterSpacing: '.18em', textTransform: 'uppercase',
      color: GREEN_INK, marginBottom: '18px'
    });
    eyebrow.textContent = CFG.eyebrow || 'Oznámení';
    card.appendChild(eyebrow);

    var title = document.createElement('div');
    css(title, {
      fontSize: '38px', lineHeight: '1.08', letterSpacing: '-.02em', fontWeight: '800',
      color: INK, marginBottom: '18px', textWrap: 'balance'
    });
    title.textContent = CFG.title || 'Zatím nepřijímáme objednávky';
    card.appendChild(title);

    var text = document.createElement('div');
    css(text, {
      fontSize: '16.5px', lineHeight: '1.65', color: BODY, maxWidth: '470px',
      margin: '0 auto', textWrap: 'pretty'
    });
    text.innerHTML = CFG.text || 'Připravujeme spuštění e-shopu. Košík si můžete klidně naplnit a projít, ale objednávku zatím nelze dokončit. Napište nám a ozveme se, jakmile bude prodej otevřený.';
    card.appendChild(text);

    var btns = document.createElement('div');
    css(btns, {
      display: 'flex', gap: '12px', justifyContent: 'center', alignItems: 'center',
      flexWrap: 'wrap', marginTop: '32px'
    });

    var primary = document.createElement('button');
    primary.type = 'button';
    css(primary, {
      appearance: 'none', border: 'none', background: INK, color: '#fff',
      borderRadius: '12px', padding: '17px 34px', fontSize: '15px', fontWeight: '600',
      cursor: 'pointer', fontFamily: 'inherit', transition: 'background .18s ease'
    });
    primary.textContent = CFG.buttonLabel || 'Rozumím';
    primary.onmouseenter = function () { primary.style.background = GREEN_INK; };
    primary.onmouseleave = function () { primary.style.background = INK; };
    btns.appendChild(primary);

    var secondary = null;
    if (CFG.linkLabel && CFG.linkUrl) {
      secondary = document.createElement('a');
      secondary.href = CFG.linkUrl;
      secondary.textContent = CFG.linkLabel;
      css(secondary, {
        color: INK, fontSize: '15px', fontWeight: '600', textDecoration: 'none',
        borderBottom: '2px solid ' + GREEN, padding: '2px 0', whiteSpace: 'nowrap'
      });
      btns.appendChild(secondary);
    }
    card.appendChild(btns);
    wrap.appendChild(card);
    document.body.appendChild(wrap);

    function fit() {
      var narrow = window.innerWidth < 620;
      css(card, {
        padding: narrow ? '40px 22px 34px' : '54px 56px 48px',
        borderRadius: narrow ? '18px' : '22px'
      });
      css(title, { fontSize: narrow ? '26px' : '38px', marginBottom: narrow ? '14px' : '18px' });
      css(text, { fontSize: narrow ? '14.5px' : '16.5px' });
      css(mark, { width: narrow ? '50px' : '62px', height: narrow ? '50px' : '62px', margin: narrow ? '0 auto 20px' : '0 auto 26px' });
      css(btns, { marginTop: narrow ? '26px' : '32px', flexDirection: narrow ? 'column' : 'row' });
      css(primary, { width: narrow ? '100%' : 'auto', padding: narrow ? '15px 20px' : '17px 34px' });
    }
    fit();
    window.addEventListener('resize', fit);

    requestAnimationFrame(function () {
      veil.style.opacity = '1';
      card.style.transform = 'translateY(0) scale(1)';
      card.style.opacity = '1';
    });

    function dismiss() {
      if (!open) { return; }
      open = false;
      markSeen();
      veil.style.opacity = '0';
      card.style.transform = 'translateY(20px) scale(.98)';
      card.style.opacity = '0';
      document.documentElement.style.overflow = prevOverflow;
      setTimeout(function () { if (wrap.parentNode) { wrap.parentNode.removeChild(wrap); } }, 400);
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') { dismiss(); } }

    var prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    close.addEventListener('click', dismiss);
    primary.addEventListener('click', dismiss);
    veil.addEventListener('click', dismiss);
    setTimeout(function () { primary.focus(); }, 420);
  }

  function show(force) {
    if (open) { return; }
    if (document.querySelector('[data-ml-notice]')) { return; }
    if (!force && CFG.repeat === false && seen()) { return; }
    open = true;
    build();
  }
  window.MLNoticeShow = function () { show(true); };

  /* ---- volitelné: zablokovat pokračování k pokladně ---- */
  function blockCheckout() {
    if (!CFG.blockCheckout) { return; }
    var sel = '[name="checkout"], a[href^="/checkout"], a[href*="/checkout"], [data-ml-checkout]';
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.getAttribute('data-ml-notice-bound')) { return; }
      el.setAttribute('data-ml-notice-bound', '1');
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(true);
      });
    });
  }

  function init() {
    // 1) stránka košíku
    var path = (window.location.pathname || '').replace(/\/+$/, '');
    if (/\/cart$/.test(path) || document.querySelector('[data-ml-cart-page]')) {
      setTimeout(function () { show(false); }, 450);
    }
    // 2) otevření košíkového draweru
    var drawer = document.querySelector('[data-ml-cart]');
    if (drawer && window.MutationObserver) {
      var wasOpen = drawer.classList.contains('is-open');
      new MutationObserver(function () {
        var isOpen = drawer.classList.contains('is-open');
        if (isOpen && !wasOpen) { setTimeout(function () { show(false); }, 260); }
        wasOpen = isOpen;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      if (wasOpen) { show(false); }
    }
    blockCheckout();
    if (window.MutationObserver) {
      new MutationObserver(blockCheckout).observe(document.body, { childList: true, subtree: true });
    }
    // ruční otevření odkazem href="#ml-notice"
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#ml-notice"]');
      if (a) { e.preventDefault(); show(true); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
